module.exports = __webpack_public_path__ + "static/media/pause.038becd8.svg";